export const BIGCOMMERCE_API_URL = 'https://api.bigcommerce.com';

export const BIGCOMMERCE_CANONICAL_STORE_DOMAIN = 'mybigcommerce.com';

const channelIdSegment =
  parseInt(process.env.BIGCOMMERCE_CHANNEL_ID) !== 1
    ? `-${process.env.BIGCOMMERCE_CHANNEL_ID}`
    : '';
const domain = `https://store-${process.env.BIGCOMMERCE_STORE_HASH}${channelIdSegment}`;

export const BIGCOMMERCE_GRAPHQL_API_ENDPOINT = `${domain}.${BIGCOMMERCE_CANONICAL_STORE_DOMAIN}/graphql`;
